<template>
  <div class="box has-background-dark is-paddingless">
      <dash-navbar :page="dashboard.page" />
      <div class="bulma-box-padding">
        <transition name="fade" mode="out-in">

          <router-view
            :api="api" :user="user"
            :character="dashboard.character"
            :direction="dashboard.characterDirection"
            :type="dashboard.page" />

        </transition>
      </div>
  </div>
</template>

<script>
import DashNavbar from '@/components/navbar/dashboard.vue'
export default {
    name:'UserDashboardView',
    beforeCreate(){
      this.$store.dispatch('setPage', {
        location:{name:'dashboard',number:6},
        title:'Panel de Control',
        breadcrumb:[
          {name:'inicio',link:this.$store.state.baseUrl,active:true, icon:'home'},
          {name:'cuenta',link:'/cuenta',active:false, icon:'address-card'}
        ]
      })
    },
    components: {
      DashNavbar
    },
    computed: {
      dashboard() {
        return this.$store.getters.GetDashboardData
      },
      api() {
        return this.$store.getters.GetApiPath
      },
      user() {
        return this.$store.getters.GetUser
      }
    }
}
</script>

<style>

</style>